import React, { useEffect, useState } from "react";
import { ColorX } from "static";
import { HtmlParserWrapper } from "Components/HtmlParserWrapper";
import { Box, Typography, Popper, Chip } from "@mui/material";
import _ from "lodash";

interface IProps {
  cssp: string;
  chipKey: string;
  chipTitle?: string;
  chips: {
    value: string;
    title: string;
    link?: string;
    titleName?: string;
    target?: string;
  }[];
}

const ZCMChips = ({ cssp, chipKey, chips, chipTitle }: IProps) => {
  const [checkEvents, setCheckEvents] = useState<boolean[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [expanded, setExpanded] = useState<boolean>(false);

  useEffect(() => {
    const length = chips.length;
    const newArray = Array(length).fill(false);
    setCheckEvents(newArray);
  }, [chips]);

  const handleMouseOver = (index: number, event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    const updatedArray = [...checkEvents];
    updatedArray[index] = true;
    setCheckEvents(updatedArray);
  };

  const handleMouseOut = (index: number) => {
    const newArray = Array(chips.length).fill(false);
    setCheckEvents(newArray);
  };

  const handleClick = (index: number) => {
    const link = chips[index].link;
    const target = chips[index].target;

    if (link) {
      if (target === "blank") {
        window.open(link, "_blank");
      } else if (target === "self") {
        window.location.href = link;
      }
    }
  };
  const renderHoverExpanded = () => {
    let rendered: any[] = [];

    chips.map((item, index) => {
      rendered.push(
        <Chip
          key={index}
          sx={{ p: "5px", m: "5px", maxWidth: "70%" }}
          label={item.titleName}
          onMouseOver={(event) => handleMouseOver(index, event)}
          //onMouseOut={() => handleMouseOut(index)}
          onClick={() => handleClick(index)}
        />
        // checkEvents[index] && (
        //   <Popper onMouseOut={() => handleMouseOut(index)} open={checkEvents[index] && anchorEl != null} placement="top" anchorEl={anchorEl} sx={{ zIndex: 15 }}>
        //     <Box sx={{ background: ColorX.GetColorCSS("Background"), maxWidth: 300, maxHeight: 200, overflowY: "auto", padding: "10px" }}>{<HtmlParserWrapper html={item.value} />}</Box>
        //   </Popper>
        // )
      );
    });

    chips && rendered.push(chips.length > 2 && <Box onClick={() => setExpanded(false)}>{`Show less`}</Box>);

    return rendered;
  };

  const renderHoverCollapsed = () => {
    let rendered: any[] = [];
    const th = 3;

    chips?.map((item, index) => {
      if (index < th) {
        rendered.push(
          <Chip
            key={index}
            sx={{ p: "5px", m: "5px", maxWidth: "70%" }}
            label={item.titleName}
            onMouseOver={(event) => handleMouseOver(index, event)}
            //onMouseOut={() => handleMouseOut(index)}
            onClick={() => handleClick(index)}
          />
          // checkEvents[index] && (
          //   <Popper onMouseOut={() => handleMouseOut(index)} open={checkEvents[index] && anchorEl != null} placement="top" anchorEl={anchorEl} sx={{ zIndex: 15 }}>
          //     <Box sx={{ background: ColorX.GetColorCSS("Background"), maxWidth: 300, maxHeight: 200, overflowY: "auto", padding: "10px" }}>{<HtmlParserWrapper html={item.value} />}</Box>
          //   </Popper>
          // )
        );
      }
    });

    chips && rendered.push(chips.length > 2 && <Box onClick={() => setExpanded(true)}>{`+${chips.length - th} ${chips.length - th > 1 ? "more" : "other"}`}</Box>);

    return rendered;
  };

  return (
    <Box className={cssp} key={chipKey} sx={{ p: 1, border: "1px solid rgba(0, 0, 0, 0.12)", borderRadius: "10px", mt: 3, background: "#F3F6F9" }}>
      {chipTitle && <Typography variant="body2">{chipTitle}</Typography>}
      {expanded ? renderHoverExpanded() : renderHoverCollapsed()}
    </Box>
  );
};

export default ZCMChips;
